import $ from "jquery";
window.$ = window.jQuery = $;
import Swiper from 'swiper';
import { Navigation, Pagination, Grid, Thumbs, Autoplay } from 'swiper/modules';
window.Swiper = Swiper;
import lightGallery from 'lightgallery';
import lgThumbnail from 'lightgallery/plugins/thumbnail'
window.lightGallery = lightGallery;
window.lgThumbnail = lgThumbnail;
import noUiSlider from "nouislider";
window.noUiSlider = noUiSlider;

window.SwiperModes = {
    'Navigation': Navigation,
    'Pagination': Pagination,
    'Grid': Grid,
    'Thumbs': Thumbs,
    'Autoplay': Autoplay
};

import IMask from 'imask';
window.IMask = IMask

import sbjs from 'sourcebuster';
window.sbjs = sbjs;
sbjs.init();

require('./components/filter')

$(document).ready(function () {
    require('./header')
    require('./footer')
    require('./good-page')
    require('./brand-page')
    require('./additions/slider')
    require('./additions/specialists')
    require('./additions/categories')
    require('./additions/default_good')
    require('./additions/reviews')
    require('./additions/blog')
    require('./additions/faq')
    require('./components/modal')
    require('./components/forms')
    require('./components/cart')
    require('./components/GTM')
    require('./components/wishlist')
    require('./components/buy-one-click')
    require('./components/phoneInputs')
    require('./components/select')
    require('./pages/checkout')
    lazyVideo()
    goodsTitleAdapt()
    setGoodsListType()
    blogNamesAdapt()


    $(window).on('resize', function () {
        goodsTitleAdapt()
        blogNamesAdapt()
    })



    $(document).on('click', '.js__row_type', function () {
        if (!$(this).hasClass('active')) {
            $(this).addClass('active')
            if ($(this).attr('data-type') == 'row') {
                $('.js__row_type[data-type="col"]').removeClass('active')
                $('.js_global__goods').addClass('row')
                localStorage.setItem('typeList', 'row')
            } else if ($(this).attr('data-type') == 'col') {
                $('.js__row_type[data-type="row"]').removeClass('active')
                $('.js_global__goods').removeClass('row')
                localStorage.removeItem('typeList')
            }
        }
    })

    $(document).on('click', '.js_global__counter-btn', function () {
        setGlobalCounter($(this))
    })

    $(document).on('click', '.js_cabinet__logout', function () {
        cabinetLogout()
    })
})

function cabinetLogout() {
    $.post(requests.postLogout, function (data) {
        if (data.status == 'success') {
            window.location.reload()
        }
    })
}

function setGlobalCounter(button) {
    if (!button.hasClass('disabled')) {
        const wrapper = button.closest('.js_global__counter')
        const btnMinus = wrapper.find('.js_global__counter-btn[data-type=minus]')
        const btnPlus = wrapper.find('.js_global__counter-btn[data-type=plus]')
        const input = wrapper.find('.js_global__counter-input')
        const type = button.attr('data-type')
        const numMin = btnMinus.attr('data-min')
        const numMax = btnPlus.attr('data-max')
        let value = input.val()
        if (type == 'minus') {
            value--
            input.val(value)
            input.attr('data-btn', 'minus')
        } else {
            value++
            input.val(value)
            input.attr('data-btn', 'plus')
        }
        if (numMax && value >= numMax) {
            btnPlus.addClass('disabled')
        } else {
            btnPlus.removeClass('disabled')
        }
        if (value <= numMin) {
            btnMinus.addClass('disabled')
        } else {
            btnMinus.removeClass('disabled')
        }
        input.trigger('change')
    }
}

function lazyVideo() {
    let scrollTop = $(window).scrollTop() + $(window).height()
    videoPosition(scrollTop)
    $(document).on('scroll', function () {
        scrollTop = $(window).scrollTop() + $(window).height()
        videoPosition(scrollTop)
    })
}

function videoPosition(scrollTop) {
    $(document).find('.js_lazy').each((i, el) => {
        if (!$(el).attr('src') || $(el).attr('src') == '') {
            let position = $(el).closest('video').offset().top
            if (scrollTop > position) {
                $(el).attr('src', $(el).attr('data-src'))
                $(el).closest('video').get(0).load()
            }
        }
    })
}

function goodsTitleAdapt() {
    if ($('.js_global__goods').length) {

        let goods = $('.js_global__goods').find('.js_goods__item .js_slider-vertical-name')
        let width = $(window).outerWidth()
        let height = [[]]
        let colNum = 3
        if (568 <= width && width < 1535) {
            colNum = 2
        } else if (width < 568) {
            colNum = 1
        }
        goods.removeAttr('style')
        if (colNum > 1) {
            goods.each((i, el) => {
                let titleHeight = $(el).innerHeight()
                height[height.length - 1].push(titleHeight)
                if ((i + 1) % colNum === 0 && i !== goods.length - 1) {
                    height.push([])
                }
            })
            let newHeight = height.reduce((acc, el, i) => {
                el.forEach((elem, ind) => {
                    if (!acc[i] || acc[i] < el[ind]) {
                        acc[i] = elem
                    }
                })
                return acc
            }, [])
            goods.each((i, el) => {
                let index = Math.floor(i / colNum)
                $(el).css('height', newHeight[index])
            })
        }
    }
}

function setGoodsListType() {
    if (localStorage.getItem('typeList') && localStorage.getItem('typeList') == 'row') {
        $('.js_global__goods').addClass('row')
        $('.js__row_type').removeClass('active')
        $('.js__row_type[data-type="row"]').addClass('active')
    }
}

function blogNamesAdapt() {
    if ($('.js_blog-page__list').length) {
        $('.js_blog-page__list').each((i, el) => {
            const items = $(el).find('.js_blog-page__item')
            if (items.length) {
                let cols = 4
                let height = []
                let heightCat = []
                if ($(window).outerWidth() < 1536 && $(window).outerWidth() > 767) {
                    cols = 3
                } else if ($(window).outerWidth() < 768) {
                    cols = 2
                }
                let rows = Math.ceil(items.length / cols)
                for (let row = 1; row <= rows; row++) {
                    items.each((k, item) => {
                        let maxIndex = row * cols - 1
                        let minIndex = row * cols - cols
                        if (k >= minIndex && k <= maxIndex) {
                            let name = $(item).find('.js_blog-page__item-name')
                            let cat = $(item).find('.js_blog-page__item-cat')
                            name.removeAttr('style')
                            cat.removeAttr('style')
                            let nameHeight = Math.ceil(name.innerHeight())
                            let catHeight = Math.ceil(cat.innerHeight())
                            if (!height[row - 1] || nameHeight > height[row - 1]) {
                                height[row - 1] = nameHeight
                            }
                            if (!heightCat[row - 1] || catHeight > heightCat[row - 1]) {
                                heightCat[row - 1] = catHeight
                            }
                        }
                    })
                }
                for (let row = 1; row <= rows; row++) {
                    items.each((k, item) => {
                        let maxIndex = row * cols - 1
                        let minIndex = row * cols - cols
                        if (k >= minIndex && k <= maxIndex) {
                            let name = $(item).find('.js_blog-page__item-name')
                            let cat = $(item).find('.js_blog-page__item-cat')
                            name.css('height', height[row - 1])
                            cat.css('height', heightCat[row - 1])
                        }
                    })
                }
            }
        })
    }
}